import { render, staticRenderFns } from "./CogneetivAIDetective.vue?vue&type=template&id=292628ab&"
import script from "./CogneetivAIDetective.vue?vue&type=script&lang=js&"
export * from "./CogneetivAIDetective.vue?vue&type=script&lang=js&"
import style0 from "./CogneetivAIDetective.vue?vue&type=style&index=0&id=292628ab&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports